// Plugin
import * as Sentry from "@sentry/vue";
import router from "../router/router";

// Type
import type { App } from "vue";

export function initSentry(app: App) {
	Sentry.init({
		app,
		environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			Sentry.browserTracingIntegration({ router }),
			// Sentry.replayIntegration(),
		],
		// Performance Monitoring
		tracesSampleRate: 0, // Capture 100% of the transactions, reduce in production!
		// Session Replay
		replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}
